<template>
  <main class="content">
    <h4>Stock Status Grade</h4>
    <div class="search-bar">
      <div class="label-wrapper">
          <label>Search</label>
        </div>
        <select v-model="selectedGrowerCode" id="grower-code">
          <option disabled value="">Select Grower Code</option>
          <option v-for="code in growerCodes" :key="code" :value="code">
            {{ code }}
          </option>
        </select>
        <input type="text" v-model="selectedGrowerCode" class="grower-code-select">
        <select v-model="selectedSeason" id="season" >
          <option disabled value="">Select Season</option>
          <option v-for="sn in seasons" :key="sn" :value="sn">{{ sn }}</option>
        </select>
        <input type="text" v-model="selectedSeason" class="grower-code-select">
      <button>Search</button>
  </div>
    
    <table class="stock-table">
      <thead>
        <tr>
          <th>Grade</th>
          <th>Weight</th>
          <th>Average Price/KG</th>
          <th>Total Price</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(grade, index) in grades" :key="index">
          <td>{{ grade.grade }}</td>
          <td>{{ grade.weight }} KG</td>
          <td>${{ grade.avgPrice }}</td>
          <td>${{ grade.totalPrice }}</td>
        </tr>
        <tr>
          <td colspan="3">TOTAL</td>
          <td>${{ totalPrice }}</td>
        </tr>
      </tbody>
    </table>
  </main>
  </template>
  
  <script>
  export default {
    name: 'StockStatusGrade',
    data() {
    return {
      userName: "Florence Kaweria",
      selectedGrowerCode: "",
      selectedSeason: "",
      growerCodes: ["XBE32FO1", "ABC123", "XYZ789"],
      seasons:["2023/2024", "2095/2096", "2024/2025"],
      grades: [
        { grade: "AA", weight: 500, avgPrice: 119, totalPrice: 60345 },
        { grade: "AB", weight: 100, avgPrice: 93, totalPrice: 9300 }
      ]
    };
  },
  computed: {
    totalPrice() {
      return this.grades.reduce((sum, grade) => sum + grade.totalPrice, 0);
    }
  },
  methods: {
    search() {
      // Implement search functionality
    }
  }
  };
  </script>
  
  <style scoped>
  .search-section {
    margin: 20px 0;
    padding: 10px;
  }
  
  .search-bar {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .search-bar input {
    padding: 5px;
  }
  .table_area_box_empty {
    position: relative;
    background: #fff;
    overflow-x: auto;
    /* //border: 1px solid #707070; */
  }
  
  .table_area_box {
    position: relative;
    background: #fff;
    overflow-x: auto;
  /* //border: 1px solid #707070; */
    
  }
  
  .thead {
    background-color: #00513B !important;
    color: white;
    font-size: 12px;
  }
  
  .table tbody tr > td.actions {
    font-size: 20px !important;
    color: #733D29 !important;
    padding-top: 0px;
  }
  
  .pagination {
    background-color: red;
  }
  
  .paginationtext {
    color: #733D29;
  }
  
  .pagination > li > a,
  .pagination > li > span {
    border: 1px solid #F2D0A7;
    color: #733D29;
  }
  
  .pagination > li.active > .page-link {
    background: #00513B;
    color: #fff;
  }
  
  .table {
    overflow-x: auto;
  }
  
  td {
    max-width: 200px; /* Set a maximum width for cells */
    overflow: hidden;
    text-overflow: ellipsis; /* Show ellipsis (...) for text overflow */
    white-space: nowrap; /* Prevent text from wrapping */
  
  }

  /*
  search
  */
  .stock-status-grade {
    display: flex;
    height: 100vh;
  }
  
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background-color: #004d25;
    color: #fff;
  }
  
  .logo img {
    height: 40px;
  }
  
  .title {
    font-size: 24px;
    font-weight: bold;
  }
  
  .user-profile {
    display: flex;
    align-items: center;
  }
  
  .user-profile img {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
  
  .sidebar {
    width: 200px;
    background-color: #e9f5f1;
    padding: 20px;
  }
  
  .sidebar ul {
    list-style: none;
    padding: 0;
  }
  
  .sidebar li {
    padding: 10px 0;
    font-weight: bold;
  }
  
  .sidebar .active {
    color:#004d25;
  }
  
  .content {
    flex: 1;
    padding: 20px;
  }
  
  .search-bar {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }
  
  .search-bar label {
    margin-right: 10px;
  }
  
  .search-bar select {
    padding: 5px;
    margin-right: 10px;
  }
  
  .search-bar button {
    background-color:#004d25;
    color: white;
    border: none;
    padding: 8px 12px;
    cursor: pointer;
  }
  
  .stock-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .stock-table th, .stock-table td {
    padding: 10px;
    border: 1px solid #ddd;
    text-align: left;
  }
  
  .stock-table th {
    background-color: #00513B !important;
    color: white;
    font-size: 12px;
  }
  
  .stock-table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .stock-table tr:last-child td {
    font-weight: bold;
    background-color: #dde7e4 !important;
    color: rgb(13, 12, 12);
    font-size: 12px;
  }
  .search-bar {
    display: flex;
    justify-content: space-between;  
    gap: 20px;
}

.label-wrapper {
    display: flex;
    align-items: center;
  }
  
  .label-wrapper {
    margin-right: -1px; /* Adjust to ensure no gap between label and input */
  }
  
  .custom-label {
    background-color: #f0f0f0; /* Greyish background color */
    color: #333; /* Text color */
    padding: 10px 15px; /* Padding inside the label */
    border-radius: 15px 15px 15px 15px; /* Slightly curved on the left side */
    font-size: 16px; /* Font size */
    font-weight: bold; /* Optional: makes the text bold */
    display: inline-block; /* Allows the label to fit its content */
    white-space: nowrap; /* Prevents label from wrapping to the next line */
  }
  input[type="text"] {
    padding: 10px 15px; /* Padding inside the input */
    border: 1px solid #ccc; /* Border color */
    border-radius: 15px 15px 15px 15px; /* Slightly curved on the right side */
    font-size: 16px; /* Font size */
    box-sizing: border-box; /* Ensures padding and border are included in width calculation */
    outline: none; /* Removes the default focus outline */
  }
  .grower-code-select {
    background-color: #dde7e4 !important;
    width: 200px; /* Adjust width as needed */
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
  }
  </style>
  